module.exports = __webpack_public_path__ + "static/media/faq-1800.2dd9e188.webp";